module.exports = __webpack_public_path__ + "static/media/svg--packout.38d645c8.svg";